import globals from "./globals"

export default class Bootstrap {

  version: string
  country: string
  userHasOrganizations: boolean

  async load(): Promise<any> {
    let response = await globals.api.get('/a/app/bootstrap')
    let data = response.data.data
    this.version = data.version
    this.country = data.country
    this.userHasOrganizations = data.userHasOrganizations
  }

}